<div [ngClass]="rowClass">
<!-- <div [ngClass]="rowClass" style="padding-left: 15px;"> -->
	<!-- <div class="row"> -->
	<label [for]="formElement.name" [ngClass]="labelClass">
		<!-- <label [for]="formElement.name" class="col-2 col-form-label"> -->
		{{label || formElement.label}}
		<span class="mandatoryColor" *ngIf="(label || formElement.label) && (required || formElement.required || formElement.showAstrisk)">*</span>
	</label>
	<div [ngClass]="inputClass">
		<!-- <div class="col-5"> -->
		<input autocomplete="off" [disabled]="(formElement.disableStartDate || formElement.disabled) ? true: null" (keydown)="discardKey($event)" (blur)="fromDate= dp.value; onChange('fromDate'); onChange('fromDate')" [class]="FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.default"
		 [id]="formElement.elements[0].id || formElement.elements[0].name ||
  'fromDate'" type="text" [placeholder]="formElement.elements[0].placeholder" [name]="formElement.elements[0].name" [(ngModel)]="fromDate"
		#dp>
		 <div class="input-group-append" (click)="focus(formElement.elements[0].id || formElement.elements[0].name ||
  'fromDate')">
			<span class="input-group-text">
				<i class="la la-calendar-check-o"></i>
			</span>
		</div>
	</div>
	<div [ngClass]="inputClass" *ngIf="show">
		<!-- <div class="col-5"> -->
		<input autocomplete="off" [disabled]="(formElement.disableEndDate || formElement.disabled) ? true: null" (keydown)="discardKey($event)" (blur)="toDate= dp1.value; onChange('toDate'); onChange('toDate')" class="form-control m-input"
		 [id]="formElement.elements[1].id || formElement.elements[1].name" type="text" [placeholder]="formElement.elements[1].placeholder"
		 [name]="formElement.elements[1].name" [(ngModel)]="toDate" #dp1>
		 <div class="input-group-append" (click)="focus(formElement.elements[1].id || formElement.elements[1].name)">
			<span class="input-group-text">
				<i class="la la-calendar-check-o"></i>
			</span>
		</div>
	</div>
	<label *ngIf="formElement.row" [for]="formElement.name" [ngClass]="labelClass">
		<!-- <label [for]="formElement.name" class="col-4 col-form-label"> -->
	</label>
	<div [ngClass]="inputClass">
		<span *ngIf="formElement.metainfo" [ngClass]="{'infoTextColor': formElement.metainfoColor}" class="m-form__help width-100">
			{{formElement.metainfo}}<br>
		</span>
		<ng-container *ngIf="!formElement.silentRequired">
			<ng-content></ng-content>
		</ng-container>
	</div>
</div>
